/* Cards use Shopify-hosted images. TikTok connects only after activation and consent. */
(() => {
  const normalize = value => value.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
  document.querySelectorAll('[data-haarlexikon-index]').forEach(root => {
    if (root.dataset?.haarlexikonInitialized) return;
    if (root.dataset) root.dataset.haarlexikonInitialized = 'true';
    const search = root.querySelector('input[type="search"]');
    const filter = root.querySelector('select');
    const cards = [...root.querySelectorAll('[data-lesson]')];
    if (!search || !filter) return;
    const update = () => {
      const words = normalize(search.value).split(/\s+/).filter(Boolean);
      let count = 0;
      for (const card of cards) {
        const show = (!filter.value || card.dataset.topic === filter.value) && words.every(word => normalize(`${card.textContent} ${card.dataset.search || ''}`).includes(word));
        card.hidden = !show;
        if (show) count++;
      }
      root.querySelector('[role="status"]').textContent = `${count} Lernbeiträge gefunden`;
      const empty = root.querySelector('[data-empty]');if (empty) empty.hidden = count !== 0;
      const featured = root.querySelector('[data-featured]');if (featured) featured.hidden = Boolean(words.length || filter.value);
    };
    root.querySelector('[data-controls]').hidden = false;
    const filters = root.querySelector('[data-filter-controls]');if (filters) filters.hidden = false;
    root.querySelector('[data-reset]')?.addEventListener('click', () => {search.value='';filter.value='';update();search.focus();});
    search.addEventListener('input', update);
    filter.addEventListener('change', update);
    update();
  });
  // Keep every example in the HTML for no-JS readers, and place it by its authored heading when enhanced.
  document.querySelectorAll('[data-inline-video]').forEach(example => {
    const anchor = example.dataset.anchor;
    if (!anchor || !/^[A-Z0-9-]+$/i.test(anchor)) return;
    const heading = document.getElementById(anchor);
    if (!heading || !heading.closest('[data-lesson-body]')) return;
    let last = heading;
    while (last.nextElementSibling && !/^H[1-3]$/.test(last.nextElementSibling.tagName) && (!last.nextElementSibling.matches('[data-inline-video]') || last.nextElementSibling.dataset.anchor === anchor)) last = last.nextElementSibling;
    last.after(example);
  });
  const privacy = () => window.Shopify?.customerPrivacy;
  const permitted = () => Boolean(privacy()?.marketingAllowed?.());
  let pending = null;
  const players = new Map();
  const stop = video => {
    video.querySelector('iframe')?.remove();
    video.querySelector('[data-activate]').hidden = false;
    const poster = video.querySelector('[data-poster]'); if (poster) poster.hidden = false;
  };
  const initializeVideos = () => {
  for (const video of players.keys()) if (video.isConnected === false) {players.delete(video);if(pending === video)pending=null;}
  document.querySelectorAll('[data-haarlexikon-video]').forEach(video => {
    if (video.dataset.haarlexikonInitialized) return;
    video.dataset.haarlexikonInitialized = 'true';
    const button = video.querySelector('[data-activate]');
    const status = video.querySelector('[role="status"]');
    const consent = video.querySelector('[data-consent]');
    const play = () => {
      const id = video.dataset.haarlexikonVideo;
      if (!permitted() || !/^\d{15,25}$/.test(id)) return;
      for (const other of players.keys()) if (other !== video) stop(other);
      const frame = document.createElement('iframe');
      // Autoplay is requested ONLY after a visitor explicitly presses Play (and grants consent).
      frame.src = `https://www.tiktok.com/player/v1/${id}?autoplay=1&rel=0`;
      frame.title = button.dataset.title || 'Video von deinfriseur.de';
      frame.allow = 'autoplay; fullscreen'; frame.referrerPolicy = 'strict-origin-when-cross-origin'; frame.setAttribute('allowfullscreen', '');
      video.querySelector('[data-player]').replaceChildren(frame); button.hidden = true;
      const poster = video.querySelector('[data-poster]'); if (poster) poster.hidden = true;
      if (consent) consent.hidden = true;
      pending = null;
      status.textContent='Falls Dein Browser den Start blockiert, drücke Play im Video. Ist das Video nicht verfügbar, nutze den TikTok-Link.';
    };
    players.set(video, play);
    video.querySelector('[data-privacy]')?.addEventListener('click', async () => {
      pending = video;
      try {
        if (!window.privacyBanner?.showPreferences) throw new Error('Banner unavailable');
        await window.privacyBanner.showPreferences();
      } catch { status.textContent='Die Datenschutzeinstellungen sind gerade nicht verfügbar. Du kannst das Video direkt auf TikTok öffnen.'; }
    });
    video.querySelector('[data-cancel]')?.addEventListener('click', () => {
      if (pending === video) pending = null;
      if (consent) consent.hidden = true;
      status.textContent=''; button.focus();
    });
    button.addEventListener('click', () => {
      if (permitted()) { play(); return; }
      pending = video;
      if (consent) { consent.hidden = false; video.querySelector('[data-privacy]')?.focus(); }
      status.textContent='Bitte bestätige Deine Auswahl in den Datenschutzeinstellungen. Danach startet dieses Video.';
    });
  });
  };
  initializeVideos();
  document.addEventListener('haarlexikon:videos-rendered', initializeVideos);
  const consentChanged = () => {
    if (!permitted()) { for (const video of players.keys()) stop(video); pending = null; return; }
    if (pending) players.get(pending)?.();
  };
  document.addEventListener('visitorConsentCollected', consentChanged);
  document.addEventListener('shopify:consent:changed', consentChanged);
  if (!privacy() && window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], () => {});
})();
